import { Box, Grid, IconButton, Typography } from "@mui/material";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { ResType } from "types";
import { styled } from "@mui/system";
import Loader from "components/Loader";
import AccessDenied from "../../Access/accessDenide";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { formatToRupeess } from "utils/formattedAmount";
import moment from "moment";
import { getEChallanData } from "api/services/automation/income-tax-tan";

interface StyledSpanProps {
  bgColor?: string; // Define bgColor prop here
}

const StyledSpan = styled("span")<StyledSpanProps>(({ theme, bgColor }) => ({
  backgroundColor: bgColor || "#ffffff",
  //   padding: "5px",
  fontSize: "14px",
  fontWeight: "500",
  borderRadius: "5px",
}));

const TanEChallanFullView = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { data, isLoading }: ResType = useQuery(
    ["get-client-e-challan-tan", params.id],
    getEChallanData
  );

  if (isLoading) return <Loader />;
  return (
    <>
      {!data?.data && <AccessDenied />}

      {data?.data && (
        <Box m={1}>
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackIcon fontSize="small" />
            <Typography variant="subtitle2" ml={1}>
              e-Challan List
            </Typography>
          </IconButton>
          <Box height="70vh" overflow="auto">
            <Typography variant="h6" color={"primary"} mb={1} ml={1}>
              Taxpayer Details
            </Typography>
            <Box
              style={{ border: "1px solid #d1d1e0", borderRadius: "5px" }}
              p={1}
              mb={2}
              ml={1}
              mr={1}
            >
              <Grid container spacing={1}>
                <Grid item xs={3}>
                  <Box
                    style={{
                      // border: "1.5px solid #d1d1e0",
                      // padding: "3px",
                      marginBottom: "3px",
                      borderRadius: "7px",
                    }}
                  >
                    <StyledSpan
                    // bgColor="#ffffcc"
                    >
                      TAN
                    </StyledSpan>
                    <Typography variant="h6" color="primary" mb={1}>
                      {data?.data?.tan}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={3}>
                  <Box
                    style={{
                      // border: "1.5px solid #d1d1e0",
                      // padding: "3px",
                      marginBottom: "3px",
                      borderRadius: "7px",
                    }}
                  >
                    <StyledSpan
                    // bgColor="#ffe6e6"
                    >
                      NAME
                    </StyledSpan>
                    <Typography variant="h6" color="primary" mb={1}>
                      {data?.data?.name}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={3}>
                  <Box
                    style={{
                      // border: "1.5px solid #d1d1e0",
                      // padding: "3px",
                      marginBottom: "3px",
                      borderRadius: "7px",
                    }}
                  >
                    <StyledSpan
                    // bgColor="#e6ffff"
                    >
                      Assessment Year
                    </StyledSpan>
                    <Typography variant="h6" color="primary" mb={1}>
                      {data?.data?.assessmentYear}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={3}>
                  <Box
                    style={{
                      // border: "1.5px solid #d1d1e0",
                      // padding: "3px",
                      marginBottom: "3px",
                      borderRadius: "7px",
                    }}
                  >
                    <StyledSpan
                    // bgColor="#ffe6e6"
                    >
                      Financial Year
                    </StyledSpan>
                    <Typography variant="h6" color="primary" mb={1}>
                      {data?.data?.financialYear}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={3}>
                  <Box
                    style={{
                      // border: "1.5px solid #d1d1e0",
                      // padding: "3px",
                      marginBottom: "3px",
                      borderRadius: "7px",
                    }}
                  >
                    <StyledSpan
                    // bgColor="#ccfff5"
                    >
                      Tax Applicable (Major Head)
                    </StyledSpan>
                    <Typography variant="h6" color="primary" mb={1}>
                      {data?.data?.majorDesc} ({data?.data?.majorHead})
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <Box
                    style={{
                      // border: "1.5px solid #d1d1e0",
                      // padding: "3px",
                      marginBottom: "3px",
                      borderRadius: "7px",
                    }}
                  >
                    <StyledSpan
                    // bgColor="#ffe6e6"
                    >
                      Type of Payment (Minor Head)
                    </StyledSpan>
                    <Typography variant="h6" color="primary" mb={1}>
                      {data?.data?.minorDesc} ({data?.data?.minorHead})
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={3}>
                  <Box
                    style={{
                      // border: "1.5px solid #d1d1e0",
                      // padding: "3px",
                      marginBottom: "3px",
                      borderRadius: "7px",
                    }}
                  >
                    <StyledSpan
                    // bgColor="#ffe6e6"
                    >
                      Amount (in ₹)
                    </StyledSpan>
                    <Typography variant="h6" color="primary" mb={1}>
                      <CurrencyRupeeIcon sx={{ fontSize: "inherit" }} />
                      {formatToRupeess(data?.data?.totalAmt)}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <Box
                    style={{
                      // border: "1.5px solid #d1d1e0",
                      // padding: "3px",
                      marginBottom: "3px",
                      borderRadius: "7px",
                    }}
                  >
                    <StyledSpan
                    // bgColor="#ffe6e6"
                    >
                      Amount (in words)
                    </StyledSpan>
                    <Typography variant="h6" color="primary" mb={1}>
                      {data?.data?.amtInWords}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>

            <Typography variant="h6" color={"primary"} mb={1} ml={1}>
              Payment Details
            </Typography>
            <Box
              style={{ border: "1px solid #d1d1e0", borderRadius: "5px" }}
              p={1}
              mb={2}
              ml={1}
              mr={1}
            >
              <Grid container spacing={1}>
                <Grid item xs={3}>
                  <Box
                    style={{
                      // border: "1.5px solid #d1d1e0",
                      // padding: "3px",
                      marginBottom: "3px",
                      borderRadius: "7px",
                    }}
                  >
                    <StyledSpan
                    // bgColor="#ffffcc"
                    >
                      CIN
                    </StyledSpan>
                    <Typography variant="h6" color="primary" mb={1}>
                      {data?.data?.cin}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={3}>
                  <Box
                    style={{
                      // border: "1.5px solid #d1d1e0",
                      // padding: "3px",
                      marginBottom: "3px",
                      borderRadius: "7px",
                    }}
                  >
                    <StyledSpan
                    // bgColor="#ffe6e6"
                    >
                      Alternate CIN
                    </StyledSpan>
                    <Typography variant="h6" color="primary" mb={1}>
                      {data?.data?.acin}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={3}>
                  <Box
                    style={{
                      // border: "1.5px solid #d1d1e0",
                      // padding: "3px",
                      marginBottom: "3px",
                      borderRadius: "7px",
                    }}
                  >
                    <StyledSpan
                    // bgColor="#e6ffff"
                    >
                      Payment Mode
                    </StyledSpan>
                    <Typography variant="h6" color="primary" mb={1}>
                      {data?.data?.paymentModeDesc}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={3}>
                  <Box
                    style={{
                      // border: "1.5px solid #d1d1e0",
                      // padding: "3px",
                      marginBottom: "3px",
                      borderRadius: "7px",
                    }}
                  >
                    <StyledSpan
                    // bgColor="#ffe6e6"
                    >
                      Bank Name
                    </StyledSpan>
                    <Typography variant="h6" color="primary" mb={1}>
                      {data?.data?.bankName}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={3}>
                  <Box
                    style={{
                      // border: "1.5px solid #d1d1e0",
                      // padding: "3px",
                      marginBottom: "3px",
                      borderRadius: "7px",
                    }}
                  >
                    <StyledSpan
                    // bgColor="#ccfff5"
                    >
                      Bank Reference Number
                    </StyledSpan>
                    <Typography variant="h6" color="primary" mb={1}>
                      {data?.data?.brn}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <Box
                    style={{
                      // border: "1.5px solid #d1d1e0",
                      // padding: "3px",
                      marginBottom: "3px",
                      borderRadius: "7px",
                    }}
                  >
                    <StyledSpan
                    // bgColor="#ffe6e6"
                    >
                      Date of Payment
                    </StyledSpan>
                    <Typography variant="h6" color="primary" mb={1}>
                      {data?.data?.paymentTime
                        ? moment(data?.data?.paymentTime).format("MMM DD, YYYY")
                        : "-"}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={3}>
                  <Box
                    style={{
                      // border: "1.5px solid #d1d1e0",
                      // padding: "3px",
                      marginBottom: "3px",
                      borderRadius: "7px",
                    }}
                  >
                    <StyledSpan
                    // bgColor="#ffe6e6"
                    >
                      BSR code
                    </StyledSpan>
                    <Typography variant="h6" color="primary" mb={1}>
                      {data?.data?.bsrCode}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <Box
                    style={{
                      // border: "1.5px solid #d1d1e0",
                      // padding: "3px",
                      marginBottom: "3px",
                      borderRadius: "7px",
                    }}
                  >
                    <StyledSpan
                    // bgColor="#ffe6e6"
                    >
                      Tender Date
                    </StyledSpan>
                    <Typography variant="h6" color="primary" mb={1}>
                      {data?.data?.tenderDt}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <Box
                    style={{
                      // border: "1.5px solid #d1d1e0",
                      // padding: "3px",
                      marginBottom: "3px",
                      borderRadius: "7px",
                    }}
                  >
                    <StyledSpan
                    // bgColor="#ffe6e6"
                    >
                      Challan Number
                    </StyledSpan>
                    <Typography variant="h6" color="primary" mb={1}>
                      {data?.data?.challanNum}
                    </Typography>
                  </Box>
                </Grid>
                {data?.data?.subPymntMode && (
                  <Grid item xs={3}>
                    <Box
                      style={{
                        // border: "1.5px solid #d1d1e0",
                        // padding: "3px",
                        marginBottom: "3px",
                        borderRadius: "7px",
                      }}
                    >
                      <StyledSpan
                      // bgColor="#ffe6e6"
                      >
                        Sub-type of Payment
                      </StyledSpan>
                      <Typography variant="h6" color="primary" mb={1}>
                        {data?.data?.subPymntMode}
                      </Typography>
                    </Box>
                  </Grid>
                )}
                 <Grid item xs={3}>
                  <Box
                    style={{
                      // border: "1.5px solid #d1d1e0",
                      // padding: "3px",
                      marginBottom: "3px",
                      borderRadius: "7px",
                    }}
                  >
                    <StyledSpan
                    // bgColor="#ffe6e6"
                    >
                      Nature of Payment
                    </StyledSpan>
                    <Typography variant="h6" color="primary" mb={1}>
                      {data?.data?.natureOfPayment ? data?.data?.natureOfPayment : "-"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <Box
                    style={{
                      // border: "1.5px solid #d1d1e0",
                      // padding: "3px",
                      marginBottom: "3px",
                      borderRadius: "7px",
                    }}
                  >
                    <StyledSpan
                    // bgColor="#ffe6e6"
                    >
                      Nature of Payment Description
                    </StyledSpan>
                    <Typography variant="h6" color="primary" mb={1}>
                      {data?.data?.sectionDesc ? data?.data?.sectionDesc : "-"}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Typography variant="h6" color={"primary"} mb={1} ml={1}>
              Tax Deposit Details
            </Typography>

            <Box pl={2} pr={2}>
              <Grid item xs={4}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  border="1px solid #d1d1e0"
                  pl={2}
                  pr={2}
                >
                  <Typography variant="h6"> (A) Tax</Typography>
                  <Typography variant="h6">{data?.data?.basicTax}</Typography>
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  border="1px solid #d1d1e0"
                  pl={2}
                  pr={2}
                >
                  <Typography variant="h6">(B) Surcharge </Typography>
                  <Typography variant="h6">{data?.data?.surCharge}</Typography>
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  border="1px solid #d1d1e0"
                  pl={2}
                  pr={2}
                >
                  <Typography variant="h6">(C) Cess</Typography>
                  <Typography variant="h6">{data?.data?.eduCess}</Typography>
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  border="1px solid #d1d1e0"
                  pl={2}
                  pr={2}
                >
                  <Typography variant="h6">(D) Interest</Typography>
                  <Typography variant="h6">{data?.data?.interest}</Typography>
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  border="1px solid #d1d1e0"
                  pl={2}
                  pr={2}
                >
                  <Typography variant="h6">(E) Penalty</Typography>
                  <Typography variant="h6">{data?.data?.penalty}</Typography>
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  border="1px solid #d1d1e0"
                  pl={2}
                  pr={2}
                >
                  <Typography variant="h6">(F) Others</Typography>
                  <Typography variant="h6">{data?.data?.others}</Typography>
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  border="1px solid #d1d1e0"
                  pl={2}
                  pr={2}
                >
                  <Typography variant="h6">Total Amount (A+B+C+D+E+F)</Typography>
                  <Typography variant="h6">
                    {" "}
                    <CurrencyRupeeIcon sx={{ fontSize: "inherit" }} />
                    {formatToRupeess(data?.data?.totalAmt)}
                  </Typography>
                </Box>
              </Grid>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default TanEChallanFullView;
